var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import FoundNumber from './foundNumber';
export default class ListNumbers extends PureComponent {
    handleOnBuyClick() {
        const { showBuyNumberModal, number } = this.props;
        showBuyNumberModal({ number });
    }
    render() {
        const { number, country } = this.props;
        return (_jsx(FoundNumber, { number: number, country: country, onBuyClickHandle: this.handleOnBuyClick }));
    }
}
__decorate([
    boundMethod
], ListNumbers.prototype, "handleOnBuyClick", null);
